module.exports = __webpack_public_path__ + "img/cloud.f9d51e6d.png";